import api from './api';

export const fetchPractitioners = async data =>
    await api.request({
        method: 'POST',
        url: '/practitioners/public',
        data
    });
